<template>
  <div class="pending-invite-menu">
    <v-menu bottom offset-y min-width="500" max-width="500">
      <template #activator="{ attrs, on }">
        <div
          class="text-body-2 primary--text"
          v-bind="attrs"
          v-on="on"
        >
          {{ invites.length }} pending invite{{ inviteSuffix }}
        </div>
      </template>
      <v-card class="pa-2">
        <invite-user-list
          :invites="invites"
          class="mt-0"
          @revoke-invite="$emit('revoke-invite', $event)"
        />
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import InviteUserList from './InviteUserList';
import { ReviewMemberInvite } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'PendingInviteMenu',
  components: {
    InviteUserList,
  },
  props: {
    invites: {
      type: Array,
      default: () => [],
      validator: (field) =>
        typeHelpers.isArrayOfType(field, ReviewMemberInvite),
    },
  },
  emits: ['revoke-invite'],
  computed: {
    inviteSuffix() {
      return this.invites.length === 1 ? '' : 's';
    },
  },
};
</script>

<style lang="scss" scoped></style>
